import React from 'react';
import { FD132 } from '../../../services/pwd212Api';

interface Tab2Props {
  productDesc: Partial<FD132>;
  names: Record<string, string>;
  isEditing: boolean;
  getPDField: (key: keyof FD132) => FD132[keyof FD132];
  setPDField: (key: keyof FD132, value: FD132[keyof FD132]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
  isFieldDisabled: (key: string) => boolean;
}

const Tab2ProductSpec: React.FC<Tab2Props> = React.memo(({
  productDesc, names, isEditing, getPDField, setPDField, resolveSingleName, isFieldDisabled,
}) => {
  const disabled = !isEditing;

  return (
    <>
      <div className="form-section odd">
        <span className="section-tag">產品代號說明</span>
        <div className="form-grid">
          <label>產品大代號</label>
          <input type="text" style={{ maxWidth: 120 }}
            disabled={disabled}
            value={getPDField('fd132_13') as string}
            onChange={e => setPDField('fd132_13', e.target.value)}
          />

          <label>產品子代號</label>
          <input type="text" style={{ maxWidth: 120 }}
            disabled={disabled}
            value={getPDField('fd132_14') as string}
            onChange={e => setPDField('fd132_14', e.target.value)}
          />

          <label>採購人員</label>
          <div className="lookup-field">
            <input type="text" style={{ width: 100 }} maxLength={8}
              disabled={disabled}
              value={getPDField('fd132_15') as string}
              onChange={e => setPDField('fd132_15', e.target.value)}
              onBlur={() => resolveSingleName('purchaser', 'employee', getPDField('fd132_15') as string)}
            />
            <span className="lookup-name">{names.purchaser || '--'}</span>
          </div>
        </div>
      </div>

      <div className="form-section even">
        <span className="section-tag">產品資訊</span>
        <div className="form-grid">
          <label>產品名稱</label>
          <div className="span-2">
            <textarea rows={2}
              disabled={disabled}
              value={getPDField('fd132_31') as string}
              onChange={e => setPDField('fd132_31', e.target.value)}
            />
          </div>

          <label>產品規格</label>
          <div className="span-2">
            <textarea rows={2}
              disabled={disabled}
              value={getPDField('fd132_32') as string}
              onChange={e => setPDField('fd132_32', e.target.value)}
            />
          </div>

          <label>加工別</label>
          <div className="span-2">
            <textarea rows={2}
              disabled={disabled}
              value={getPDField('fd132_33') as string}
              onChange={e => setPDField('fd132_33', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="form-section odd">
        <span className="section-tag">幅寬與重量</span>
        <div className="form-grid">
          <label>針孔內(幅寬)</label>
          <input type="number" style={{ maxWidth: 100 }} step="0.01"
            disabled={disabled}
            value={getPDField('fd132_34') as number || ''}
            onChange={e => setPDField('fd132_34', parseFloat(e.target.value) || 0)}
          />

          <label>針孔外(幅寬)</label>
          <input type="number" style={{ maxWidth: 100 }} step="0.01"
            disabled={disabled}
            value={getPDField('fd132_35') as number || ''}
            onChange={e => setPDField('fd132_35', parseFloat(e.target.value) || 0)}
          />

          <label>碼重</label>
          <input type="number" style={{ maxWidth: 100 }} step="0.01"
            disabled={disabled}
            value={getPDField('fd132_36') as number || ''}
            onChange={e => setPDField('fd132_36', parseFloat(e.target.value) || 0)}
          />

          <label>平方米重</label>
          <input type="number" style={{ maxWidth: 100 }} step="0.01"
            disabled={disabled}
            value={getPDField('fd132_37') as number || ''}
            onChange={e => setPDField('fd132_37', parseFloat(e.target.value) || 0)}
          />
        </div>
      </div>
    </>
  );
});

Tab2ProductSpec.displayName = 'Tab2ProductSpec';
export default Tab2ProductSpec;
